<mat-dialog-content>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Product Created</h4>
    <i class="fas fa-times pull-right fontL3" (click)="hideModal()"></i>
  </div>
  <div class="modal-body">
    <p>You have created a new product. Do you want to add it to a productCollection?</p>
  </div>
  <div class="modal-footer gap-12">
    <button (click)="onYes()" class="btn-primary">Yes</button>
    <button (click)="onNo()" class="btn-secondary ml-3">No</button>
  </div>
</mat-dialog-content>
